module.exports = __webpack_public_path__ + "img/pay-welfare-bg.2e3bd310.png";